import DataSourceView from "./PagesDatasourcesView.js";
import ToolsetView from "./PagesToolsetsView.js";
import RelatedView from "./PagesRelatedView.js";
import FooterView from "./PagesFooterView.js";
import ConfigView from "./PagesConfigView.js";
import PagesVariablesView from "./PagesVariablesView.js";
import PagesSettingsView from "./PagesSettingsView.js";
import PermalinksView from "./PagesPermalinksView.js";
import TranslationsView from "./PagesTranslationsView.js";
import ComponentsView from "./PagesComponentsView.js";
import FontsView from "./PagesFontsView.js";
import { getSubtab, setSubtab, backfillSubtab } from "../_resources/url-state.js";
import { checkSupaAccess } from "../_resources/supa-helpers.js";

const SELECTED_SUBPANEL = 'admin.pages.selected_subpanel_id';

export default function PagesOnepageSectionView({ dom, sidebar, message, filePicker, refresh, getToken, getUserId }) {
  const {bad, info, progress, good} = message;

  const subpanels = ['toolset', 'datasources', 'related', 'footer', 'config',  'variables', 'settings', 'permalinks', 'translations', 'components', 'fonts'];
  const navItems = sidebar.selectAll(".nav-item");

  const dataSourcesView = new DataSourceView({ dom, message });
  const toolsetView = new ToolsetView({ dom, message, filePicker });
  const relatedView = new RelatedView({ dom, message, filePicker });
  const footerView = new FooterView({ dom, message, filePicker });
  const variablesView = new PagesVariablesView({ dom, message });
  const settingsView = new PagesSettingsView({ dom, message, filePicker });
  const configView = new ConfigView({ dom, message });
  const permalinksView = new PermalinksView({ dom, message, getToken });
  const translationsView = new TranslationsView({ dom, message });
  const componentsView = new ComponentsView({ dom, message, filePicker });
  const fontsView = new FontsView({ dom, message, filePicker });


  function render(page, refresh = false) {
    navItems.on('click', function(event){
        const target = d3.select(this).attr("data-route");
        event.preventDefault();
        renderSubpanelContent(target, page);
      });

    const subpanelId = getSubtab(SELECTED_SUBPANEL, subpanels);
    renderSubpanelContent(subpanelId, page);
    backfillSubtab(subpanelId);
  }

  function renderSubpanelContent(subpanelId, page) {
    setSubtab(subpanelId, SELECTED_SUBPANEL);

    const userId = getUserId();
    const hasPageEditAccess = checkSupaAccess({user: userId, scope: "site", resource: page.site, atLeast: "editor"})
      || checkSupaAccess({user: userId, scope: "page", resource: page.site + "/" + page.slug, atLeast: "editor"});
    const hasPageOwnerAccess = checkSupaAccess({user: userId, scope: "site", resource: page.site, atLeast: "owner"})
      || checkSupaAccess({user: userId, scope: "page", resource: page.site + "/" + page.slug, atLeast: "owner"});

    dom.html('');
    dom.class(`contentSection pages-${subpanelId}-view`);

    navItems.classed('active', function(){
      const target = d3.select(this).attr("data-route");
      return target === subpanelId
    });

    if (subpanelId === 'datasources') {
      dataSourcesView.render(page.id, hasPageEditAccess);
    } else
    if (subpanelId === 'toolset') {
      toolsetView.render(page.id, page.base_url, page.datasources, hasPageEditAccess);
    } else 
    if (subpanelId === 'related') {
      relatedView.render(page.id, page.base_url, hasPageEditAccess);
    } else
    if (subpanelId === 'footer') {
      footerView.render(page.id, page.base_url, hasPageEditAccess);
    } else
    if (subpanelId === 'variables') {
      variablesView.render(page.id, page.base_url, hasPageEditAccess);
    } else
    if (subpanelId === 'settings') {
      settingsView.render(page.id, page.base_url, page.slug, page.site, {good, bad, refresh}, hasPageEditAccess, hasPageOwnerAccess);
    } else
    if (subpanelId === 'config') {
      configView.loadConfig(page.id, page.site, page.slug, hasPageEditAccess);
    } else
    if (subpanelId === 'permalinks') {
      permalinksView.render(page.id, hasPageEditAccess);
    } else
    if (subpanelId === 'translations') {
      translationsView.render(page.id, page.site, page.slug, hasPageEditAccess);
    } else
    if (subpanelId === 'components') {
      componentsView.render(page.id, page.base_url, hasPageEditAccess);
    } else
    if (subpanelId === 'fonts') {
      fontsView.render(page.id, page.base_url, hasPageEditAccess);
    } else {
      dom.append('p')
        .text(`Content for ${!page.slug || page.slug==="__home__" ? "Home" : page.slug} ${subpanelId} subpanel.`);
    }
  }

  return { render };
}
